module.exports = require("pouchdb");


//////////////////
// WEBPACK FOOTER
// external "pouchdb"
// module id = 46
// module chunks = 0